export class CreateOTPRequest {
  otpRequestID: string;

  constructor(otpRequestID: string) {
    this.otpRequestID = otpRequestID;
  }
}
